import React from 'react'

import TestimonialSingle from './TestimonialSingle'
import TestimonialTwoCol from './TestimonialTwoCol'
import TestimonialBanner from './TestimonialBanner'

const Testimonial = ({ options, testimonials }) => {
    let output = null
    switch (options.type) {
    case 'stand-alone':
        output = <TestimonialSingle options={options} />
        break
    case '2col':
        output = <TestimonialTwoCol options={options} />
        break
    case 'image':
        output = <TestimonialTwoCol type="media" options={options} />
        break
    default:
        output = <TestimonialBanner testimonials={testimonials} />
    }
    return output
}

export default Testimonial
